module.exports = "./img/dc544ea419bb2ac903c43527479cdbaf.jpg";